import TableFilterableMultipleDeletable from './filterable_multiple_deletable';
import Functions from '../functions';

export default class TableOrder extends TableFilterableMultipleDeletable {

  init() {

    super.init();

    Functions.initSelectAllButtons();
    Functions.initUnselectAllButtons();
    Functions.initPopupImages();
  }

  _reinitDynamicBlock(html) {
    super._reinitDynamicBlock(html);
    Functions.initPopupImages();
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/table/order.js
 **/